import axios from '../axios'
import i18n from '../i18n'
import configurations from '../configurations'

const defaultData = {
  category: '',
  channel: 'aplikasi',
  date: new Date().toISOString(),
  description: '',
  location: '',
  complainant: {
    email: '',
    full_name: '',
    ic_num: '',
    phone: ''
  },
  status: 'new',
  type: 'complaint',
  user: ''
}

const complaint = {
  namespaced: true,
  state: {
    camera: false,
    data: defaultData,
    error: null,
    file: null,
    id: '',
    iterator: {
      rowsPerPageItems: [
        5,
        10,
        25,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
      ]
    },
    list: [],
    loading: false,
    optionUpload: 'attachment',
    rules: {
      full_name: 'required',
      ic_no: 'required',
      description: 'required',
      email_address: 'required|email',
      phone: 'required',
      location: 'required',
      category: 'required',
      file: 'required'
    }
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  actions: {
    fetchData: async function (context, payload = defaultData) {
      context.commit('setLoading', { loading: true })
      try {
        const response = await axios.post(`/query`, { url: btoa(`/complaint/${payload.id}`) })
        response.data.attachmentUrl = configurations.WORKER + '/getAttachments/complaint'
        context.commit('setData', { data: response.data })
        context.commit('setError', { error: null })
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    fetchList: async function (context, payload = defaultData) {
      context.commit('setLoading', { loading: true })
      try {
        const apiUrl = `/complaint/_design/query/_view/query?startkey=["complaint","${
          context.rootState.auth.session.name
        }",{}]&endkey=["complaint","${
          context.rootState.auth.session.name
        }"]&descending=true&include_docs=true`

        let response = await axios.post(`/query`, { url: btoa(apiUrl) })
        context.commit('setList', {
          list: response.data.rows.length > 0 ? response.data.rows.map(row => row.doc) : []
        })
        context.commit('setError', { error: null })
        return response.data
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    patchComplainant: async function (context, payload = {}) {
      const data = Object.assign({}, context.state.data.complainant, payload)
      context.commit('setComplainant', { data })
    },
    patchData: async function (context, payload = {}) {
      const data = Object.assign({}, context.state.data, payload)
      if (payload.file) {
        data.file = payload.file
      }
      if (payload.geolocation) {
        data.geolocation = payload.geolocation
      }
      context.commit('setData', { data })
    },
    resetData: async function (context, payload = {}) {
      context.commit('setData', { data: defaultData })
      context.commit('setId', { id: '' })
      context.commit('setCamera', { camera: false })
      context.commit('setError', { error: null })
      context.commit('setLoading', { loading: false })
      context.commit('setFile', { file: null })
    },
    submitData: async function (context, rootState, payload = defaultData) {
      const data = Object.assign({}, context.state.data)
      data.council = 'mpt'
      const apiUrl = '/complaint/_design/backend/_update/complaint'
      context.commit('setLoading', { loading: true })
      data.user = data.complainant.email

      try {
        data._id = new Date().getTime().toString()
        data.date = new Date().toISOString()
        data.type = 'complaint'
        data.status = 'new'
        data.channel = 'aplikasi e-services'
        data.location = data.location.toUpperCase()
        data.complainant.full_name = data.complainant.full_name.toUpperCase()
        data.complainant.email = data.complainant.email.toLowerCase()

        let response = await axios.post(`/query`, { url: btoa(apiUrl), payload: data })
        response = await axios.post(`/query`, { url: btoa(`/complaint/${response.data._id}`) })
        if (response.data._id && context.state.file !== null) {
          const config = {
            headers: {
              'Content-Type': context.state.file.type,
              'If-Match': response.data._rev
            }
          }
          response = await axios.put(
            `/uploadAttachment/complaint/${response.data._id}/${context.state.file.name ||
              'photo-' + new Date().getTime().toString() + '.jpg'}`,
            context.state.file,
            config
          )
        }
        context.commit('setError', { error: null })
        this.dispatch('snackbar/setSnackBar', {
          color: 'success',
          message: i18n.t('submit_successful'),
          visible: true
        })
        return response.data
      } catch (error) {
        console.error(error)
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('submit_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    }
  },
  mutations: {
    setCamera: function (state, payload = { camera: false }) {
      state.camera = payload.camera
    },
    setError: function (state, payload = { error: null }) {
      state.error = payload.error
    },
    setId: function (state, payload = { id: '' }) {
      state.id = payload.id
    },
    setLoading: function (state, payload = { loading: false }) {
      state.loading = payload.loading
    },
    setComplainant: function (state, payload = { data: defaultData }) {
      state.data.complainant = payload.data
    },
    setData: function (state, payload = { data: defaultData }) {
      state.data = payload.data
    },
    setList: function (state, payload = { list: [] }) {
      state.list = payload.list
    },
    setFile: function (state, payload = { file: null }) {
      state.file = payload.file
    },
    setOptionUpload: function (state, payload = { optionUpload: 'camera' }) {
      state.optionUpload = payload.optionUpload
    }
  }
}

export default complaint
